export type InspectionDashboardPeriod = Readonly<{ mode: 'all' } | { from: string; to: string }>;

export function normalizeInspectionDashboardPeriod(
  period: InspectionDashboardPeriod = { mode: 'all' },
): InspectionDashboardPeriod {
  if ('mode' in period && period.mode === 'all') return { mode: 'all' };
  if (!('from' in period) || !('to' in period)) throw new Error('집계 기간을 확인해 주세요.');
  const date = (value: string) => {
    if (!/^\d{4}-\d{2}-\d{2}$/u.test(value)) throw new Error('집계 날짜를 확인해 주세요.');
    const parsed = new Date(`${value}T00:00:00.000Z`);
    if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== value)
      throw new Error('집계 날짜를 확인해 주세요.');
    return parsed.getTime();
  };
  const start = date(period.from),
    end = date(period.to);
  if (start > end || end - start >= 370 * 86_400_000)
    throw new Error('집계 기간은 시작일부터 최대 370일로 선택해 주세요.');
  return { from: period.from, to: period.to };
}

export function inspectionDashboardPeriodKey(period?: InspectionDashboardPeriod) {
  const value = normalizeInspectionDashboardPeriod(period);
  return 'mode' in value ? 'all' : `${value.from}:${value.to}`;
}
